import { Resource_AppointmentMsg, Resource_AppointmentRequestMsg } from '@/generated/graphql';
import { RequestAddition } from '@components/appointment-request-details/request-addition';
import { Maybe } from '@graphql-tools/utils/typings/types';
import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface AppointmentRequestGroupAppointmentProps {
  appointmentRequest: Nullable<Resource_AppointmentRequestMsg>;
  appointments: Maybe<(Maybe<Resource_AppointmentMsg> | undefined)[]> | undefined;
}

export const AppointmentRequestGroupAppointment: FC<AppointmentRequestGroupAppointmentProps> = ({
  appointmentRequest,
  appointments,
}) => {
  const { formatMessage } = useIntl();

  const quota = appointmentRequest?.appointmentType?.groupAppointmentQuota;

  return appointments && appointments.length > 0 ? (
    <Card>
      <Title level={3} style={{ fontWeight: 'bold' }}>
        {formatMessage({ id: 'appointment-request.group-appointment' })}
      </Title>
      {appointments?.map((appointment, idx) => {
        return (
          <div key={idx}>
            {/* This will only print the current portal users comment since the backend ensures only the current attendee is being returned */}
            {appointment?.requestBasicInfos?.map((info, idx) => (
              <RequestAddition addition={info?.comment} key={idx} />
            ))}
            <p>{formatMessage({ id: 'appointment-request.group-appointment.description' })}</p>
            {quota && (
              <p>
                {formatMessage(
                  { id: 'appointment-request.group-appointment.quota.description' },
                  { quota },
                )}
              </p>
            )}
          </div>
        );
      })}
    </Card>
  ) : null;
};
